import { useField } from 'formik';
import { FC } from 'react';

import Form from '@controls/Form';

import Switcher from '@components/controls/Switcher';

import { getFieldName } from '../../../../utils';
import { containerStyles } from './styles';

interface IsPreOrderSwitcherProps {
    fieldPrefix: string;
    onFilterChange?: (fieldName: string, newValue?: (string | number)[]) => void;
}

const IsPreOrderSwitcher: FC<IsPreOrderSwitcherProps> = ({ fieldPrefix, onFilterChange }) => {
    const fieldName = getFieldName('popup_isPreOrder', fieldPrefix);
    const [field] = useField<boolean>(fieldName);

    return (
        <div css={containerStyles}>
            <span>В наличии</span>
            <div css={{ width: '48px', flexShrink: 0 }}>
                <Form.Field name={fieldName}>
                    <Switcher
                        color="secondary"
                        name={fieldName}
                        onChange={() => {
                            const currentValue = field.value;
                            const newValue = currentValue ? ['true'] : [];
                            onFilterChange?.(fieldName, newValue);
                        }}
                    />
                </Form.Field>
            </div>
        </div>
    );
};

export default IsPreOrderSwitcher;
